import { Key, useEffect, useState } from 'react';
import { Box, FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { observer } from 'mobx-react';

import charactersStore from 'stores/charactersStore';
import { ICharacterDto } from 'shared/interfaces'; // ✅ используем напрямую

import MainPageHeader from '../MainPage/components/MainPageHeader';
import CharactersTable from './components/CharactersTable/CharactersTable';

import './DoctorPersonalPage.scss';

const DoctorPersonalPage: React.FC = () => {
  const [availableCharacters, setAvailableCharacters] = useState<ICharacterDto[]>([]);
  const [selectedCharacters, setSelectedCharacters] = useState<ICharacterDto[]>(
      JSON.parse(localStorage.getItem('selectedCharacters') || '[]')
  );
  const [selectedLevel, setSelectedLevel] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      await charactersStore.getCharacters();

      if (selectedCharacters.length) {
        const filtered = charactersStore.characters.filter(
            (char) => !selectedCharacters.find((sel) => sel.id === char.id)
        );
        setAvailableCharacters(filtered);
      } else {
        setAvailableCharacters(charactersStore.characters);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    localStorage.setItem('selectedCharacters', JSON.stringify(selectedCharacters));
  }, [selectedCharacters]);

  const handleAddCharacter = (character: ICharacterDto) => {
    if (!selectedLevel) return;
    const alreadyAdded = selectedCharacters.some((c) => c.id === character.id);
    if (!alreadyAdded) {
      // ✅ добавляем выбранный уровень как "виртуальное поле"
      setSelectedCharacters([...selectedCharacters, { ...character, level: +selectedLevel }]);
      setAvailableCharacters(availableCharacters.filter((c) => c.id !== character.id));
    }
  };

  const handleDeleteCharacter = (characterToDelete: ICharacterDto) => {
    setSelectedCharacters(selectedCharacters.filter((c) => c.id !== characterToDelete.id));
    setAvailableCharacters([characterToDelete, ...availableCharacters]);
  };

  return (
      <div className="background-container">
        <Box>
          <MainPageHeader />
        </Box>

        <div className="select_container">
          <FormControl sx={{ minWidth: 320 }}>
            <InputLabel id="select-level-label">Выберите уровень</InputLabel>
            <Select
                labelId="select-level-label"
                id="select-level"
                value={selectedLevel}
                label="Выберите уровень"
                onChange={(e) => setSelectedLevel(e.target.value)}
            >
              <MenuItem value="1">Level 1</MenuItem>
              <MenuItem value="2">Level 2</MenuItem>
              <MenuItem value="3">Level 3</MenuItem>
            </Select>
          </FormControl>

          <div className="select_button-container">
            {availableCharacters.map((char: ICharacterDto, index: Key) => (
                <div key={index}>
                  <button
                      className="select_button-user"
                      onClick={() => handleAddCharacter(char)}
                  >
                    {char.name} ({char.race} {char.charClass})
                  </button>
                </div>
            ))}
          </div>
        </div>

        <CharactersTable
            characters={selectedCharacters}
            setCharacters={setSelectedCharacters}
            onDelete={handleDeleteCharacter}
        />
      </div>
  );
};

export default observer(DoctorPersonalPage);
